"use client"

import { useState } from "react"
import "./WebFaq.css"

const faqData = [
  {
    question: "What is Web Development?",
    answer:
      "Web Development is the process of developing websites and applications. It includes various specialisations, such as working on the web server, web engineering, network security configuration, and graphic design development. However, the everyday use of web development typically refers to coding or writing markups.",
  },
  {
    question: "What does a web developer do?",
    answer:
      "The work of a professional Web Developer is to build websites or web applications. He is in charge of the website's performance and capacity, and works side-by-side with the web design team in the front-end development to make sure the website has a responsive design, is easy-to-use and appealing to navigate.",
  },
  {
    question: "What is a web application?",
    answer:
      "Web applications are programs or software hosted on a remote server, and accessible from any web browser on any device; it’s basically an application that interacts with a network.",
  },
  {
    question:
      "What are examples of web applications?",
    answer:
      "There are 10 types of web applications, each with their own business benefits:• Static web application• Dynamic web application• E-commerce web application• Content management system web application• Single-page web application• Multiple-pages web application• Portal web application• Animated web applicationRich internet web application• Progressive web applicationWant to learn more about each type of web application? Take a look at our blog post about 10 types of web applications and how you can use them.",
  },
  {
    question: "What is the difference between website and webapp?",
    answer:
      "A web application is a piece of software that can be accessed by a browser - which is an application that is used to browse the internet. A web app combines server-side scripts and client-side scripts to showcase information, and it requires a server to manage requests from the users. It is designed mainly for interaction with end users, and users can also manipulate the data. Examples of web applications are Facebook, Netflix, Amazon and Ebay.A website, on the other hand, is a collection of web pages that contains images, text, audio, video, and so on. It can consist of one page, two pages, or a number of pages. A website user can only read the content but not manipulate it. Examples of websites are blogs, a forum, or the government’s page where you can read about government related topics or issues.",
  },
  {
    question: "How long does it take to build a website and web application?",
    answer:
      "If your website or web app is institutional and needs to be redesigned, the average working time is from 2 to 3 months. If you already have the designs, we can implement them in 2 to 4 weeks.If the website or web app project is e-commerce, we need to validate the average working time with the technical team as it can take up to 6 months, depending on the project’s complexity.",
  },
  {
    question:
      "How much does it cost to build a website and web application?",
    answer:
      "If your website project needs a redesign, the average hourly cost of a software developer working on your product varies between $50 000* to $80 000*. For implementation solely, the average costs range between $10 000* to $20 000*.If you’re looking to build a web app, the average cost is from $150 000 to $400 000, depending on the project’s complexity.*Note: Rates may vary based on currency.Useful link:• Time & Materials contract - which one is the best option for your software, web, or mobile app development product?",
  },
  {
    question:
      "Do you redesign existing websites?",
    answer:
      "Yes, we do. Our web design and development service covers redesigning existing websites. We help you shape digital products from scratch or improve your existing ones, always ensuring they're user-friendly.",
  },
 
]

const FAQSection = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section754">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT OUR</h1>
          <h2 className="sub-title">WEB DEVELOPMENT SERVICES</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default FAQSection
